import L from 'leaflet'; // Import Leaflet directly
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer, ZoomControl, useMap } from 'react-leaflet';
import markerImage from '../../../assets/images/marker.png';
import userMarker from '../../../assets/images/user-marker.png';
import { useJobsData } from 'src/context/job-context';
import { Box, Typography, Button, Tooltip, Link, Portal } from '@mui/material';
import { useLocationFields } from 'src/context/location-context';
import { useEffect, useState, useRef } from 'react';
import Iconify from 'src/components/iconify';
import { fDate, formatPrice } from 'src/utils/format-time';
import { usePositionData } from 'src/context/current-location-context';
import './style.css';
import BeforeAfterModal from './before-after-modal';
import { useBoolean } from 'src/hooks/use-boolean';
import imageIcon from '../../../assets/images/imageIcon.png';
import 'leaflet.heat';
import ToggleSwitch from 'src/components/header-filters/ToggleSwitch';
import ToggleSwitchFilterJobs from 'src/components/header-filters/ToggleSwitchFilterJobs';
import { useAuthContext } from 'src/auth/hooks';
import { LoadingScreen } from 'src/components/loading-screen';
import RouteModal from './route-modal';
import { LoadingButton } from '@mui/lab';
import { useGetCampaigns } from 'src/api/campaign';

// Create a custom icon for markers

const userIcon = L.icon({
  iconUrl: userMarker,
  iconSize: [40, 54],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

export default function Map() {
  const { campaigns } = useGetCampaigns();

  const useResponsiveIcon = () => {
    const [iconSize, setIconSize] = useState(window.innerWidth < 768 ? [30, 40] : [54, 64]);

    useEffect(() => {
      const handleResize = () => {
        setIconSize(window.innerWidth < 768 ? [30, 40] : [54, 64]);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return L.icon({
      iconUrl: markerImage,
      iconSize: iconSize,
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });
  };

  const customIcon = useResponsiveIcon();

  const open = useBoolean();
  const [IsHeatMap, setIsHeatMap] = useState(false);
  const [loading, seLoading] = useState(false);
  const [markers, setMarkers] = useState([]);
  const { JobsData, isHeatMap, myJob } = useJobsData();
  console.log(myJob, '---------------');
  // console.log(JobsData, 'JobsData-----------------');
  const { positionData, updatePositionData } = usePositionData();
  const [selectedJob, setSelectedJob] = useState([]);
  const [heatmapLayer, setHeatmapLayer] = useState(null);

  const { locationData, resetLocationData, updateLocationData } = useLocationFields();
  const [latitude, longitude] = positionData.currentPosition;

  const mapRef = useRef(null);
  const { user } = useAuthContext();
  const confirm = useBoolean();

  console.log(user, 'user is showing here');

  // console.log('user fron context', user);
  useEffect(() => {
    if (mapRef.current) {
      const newCenter = [locationData.lat || latitude, locationData.lng || longitude];
      // const newCenter = [37.7749,-122.4194];
      mapRef.current.setView(newCenter, 13);
    }
  }, [
    locationData,
    locationData.lat,
    locationData.lng,
    latitude,
    longitude,
    mapRef,
    JobsData?.jobs,
  ]);

  const handleOpenModal = (item) => {
    setSelectedJob(item);
    open.onTrue();
  };

  const handleOpenModalHeatMap = (encodedJobData) => {
    const jobData = JSON.parse(decodeURIComponent(encodedJobData));
    console.log(jobData, 'ahsgdasjaygdasgdjh');
    setSelectedJob(jobData);
    open.onTrue();
  };

  const handleOpenRouteModal = () => {
    confirm.onTrue();
  };

  window.handleOpenModalHeatMap = handleOpenModalHeatMap;
  window.handleOpenRouteModal = handleOpenRouteModal;
 
  useEffect(() => {
    if (!mapRef.current) return;

    if (heatmapLayer) {
      mapRef.current.removeLayer(heatmapLayer);
      setHeatmapLayer(null);
    }

    if (isHeatMap) {
      const heatMapData = JobsData?.jobs
        ?.map((item) => {
          if (!item?.location?.coordinates) return null;

          const [jobLongitude, jobLatitude] = item.location.coordinates;
          const price = item?.price || 0;
          // const density = 0.1 * (Math.floor(price / 5000) + 1);
          const maxPrice = Math.max(...JobsData?.jobs.map((j) => j?.price || 0));
          let density = 0.1;
          // const density = price / maxPrice; // Normalize to 0-1 range
          if (price > 5000) {
            density = 0.1 + Math.min(0.9, ((price - 5000) / 15000) * 0.9);
          }
          if (myJob && item.salesRepId == user?._id) {
            return { lat: jobLatitude, lng: jobLongitude, density, job: item };
          } else if (!myJob) {
            return { lat: jobLatitude, lng: jobLongitude, density, job: item };
          }

          // const price = item?.price || 0;

          // let intensity = 0.1;

          // if (price > 5000) {
          //   intensity = 0.1 + Math.min(0.9, ((price - 5000) / 15000) * 0.9);
          // }
          // return [jobLatitude, jobLongitude, intensity];
        })
        .filter(Boolean);

      // console.log(heatMapData, 'heatmapdata--------')

      const newHeatmapLayer = L.heatLayer(heatMapData, {
        radius: 25, // Slightly larger radius for better visibility
        blur: 20, // Increased blur for smoother transitions
        maxZoom: 17,
        minOpacity: 0.4,
        max: 1.0, // Set maximum value for normalization

        // Enhanced color gradient for better price differentiation
        gradient: {
          0.1: '#74c0ff', // Light blue for lowest prices (below $5000)
          0.3: '#0072ff', // Medium blue
          0.5: '#00c853', // Green for medium prices
          0.7: '#ffab00', // Orange for higher prices
          0.85: '#ff6d00', // Dark orange
          1.0: '#d50000', // Deep red for highest prices
        },
      }).addTo(mapRef.current);

      setHeatmapLayer(newHeatmapLayer);

      const map = mapRef.current;
      const popup = L.popup({ closeButton: false });
      let popupOpen = false;

      const tooltip = L.tooltip({ permanent: false, direction: 'top' });
      let tooltipOpen = false;

      const getDistance = (latlng1, latlng2) => {
        return map.latLngToLayerPoint(latlng1).distanceTo(map.latLngToLayerPoint(latlng2));
      };

      const onMouseMove = (e) => {
        let closestPoint = null;
        let minDistance = Infinity;

        heatMapData.forEach((point) => {
          const distance = getDistance(e.latlng, L.latLng(point.lat, point.lng));
          if (distance < minDistance && distance < 20) {
            // Reduce distance threshold for better accuracy
            minDistance = distance;
            closestPoint = point;
          }
        });

        if (closestPoint) {
          tooltip.setLatLng([closestPoint.lat, closestPoint.lng]).setContent(`<div style="
            font-size: 13px;
            font-weight: bold;
            padding: 6px 12px;
            border-radius: 30px;
            text-align: center;
            display: inline-block;
            white-space: nowrap;
          ">
            Click to view job details
          </div>
          `);

          if (!tooltipOpen) {
            map.openTooltip(tooltip);
            tooltipOpen = true;
          }

          map.getContainer().style.cursor = 'pointer';
        } else {
          if (tooltipOpen) {
            map.closeTooltip(tooltip);
            tooltipOpen = false;
          }

          map.getContainer().style.cursor = '';
        }
      };

      map.on('mousemove', onMouseMove);

      const onMapClick = (e) => {
        if (popupOpen) {
          map.closePopup(popup);
          popupOpen = false;
          return;
        }

        let closestPoint = null;
        let minDistance = Infinity;

        heatMapData.forEach((point) => {
          const distance = getDistance(e.latlng, L.latLng(point.lat, point.lng));
          if (distance < minDistance && distance < 20) {
            // Reduce click distance threshold
            minDistance = distance;
            closestPoint = point;
          }
        });

        if (closestPoint) {
          popup
            .setLatLng([closestPoint.lat, closestPoint.lng])
            .setContent(
              `
        <div style="display: flex; justify-content: space-between; font-size: 14px; font-weight: bold; color: #666;">
          <span>Job #: <span style="color: black;">${
            closestPoint.job?.jobNumber || 'N/A'
          }</span></span>
          <span>Date: <span style="color: black;">${
            fDate(closestPoint.job?.installationDate) || 'N/A'
          }</span></span>
        </div>
        
        <div style="display: flex; justify-content: space-between; font-size: 14px; color: #666; font-weight: bold; margin-top: 6px;">
          <span>Price: <span style="color: black;">$${formatPrice(
            closestPoint.job?.price || 0
          )}</span></span>
          <span>Sales Rep: <span style="color: black;">${
            closestPoint.job?.rep || closestPoint.job?.userName || 'N/A'
          }</span></span>
        </div>
        
        <div style="display: flex; justify-content: space-between; align-items: center; font-size: 14px; font-weight: bold; margin-top: 6px; color: #666;">
          <div>Lead Code: <span style="margin-left: 5px; color: black;">N/A</span></div>
          ${user?.roleName === 'Marketing Manager' ? `<div style="margin-left: 12px; display: flex; align-items: center; background: #34d399; color: white; font-size: 14px; font-weight: bold; padding: 4px 10px; border-radius: 20px; cursor: pointer; transition: background 0.2s ease-in-out;"
              onmouseover="this.style.background='#059669'" 
              onmouseout="this.style.background='#34d399'">
              Route#: 
              <span style="cursor: pointer; text-decoration: underline; margin-left: 5px;" onclick="handleOpenRouteModal()">2255685</span>
          </div>`: ''}
        </div>
        
        <hr style="margin: 10px 0; border: none; border-top: 1px solid #ddd;">
        
        <div style="margin-top: 8px; font-size: 14px; font-weight: bold; color: #666; display: flex; align-items: flex-start;">
        <span>Address:</span>
        <span style="color: black; margin-left: 5px; display: flex;  gap: 5px;">
          <span style="filter: blur(5px);">****</span>
          ${closestPoint.job?.address?.streetName || ''}, 
          ${closestPoint.job?.address?.city || ''}, 
          ${closestPoint.job?.address?.state || ''}, 
          ${closestPoint.job?.address?.zip || ''}
          
          ${
            closestPoint.job?.images?.beforeImages?.length > 0
              ? `<span style="cursor: pointer;" 
                  onclick="handleOpenModalHeatMap('${encodeURIComponent(
                    JSON.stringify(closestPoint.job)
                  )}')">
                  <img src="${imageIcon}" alt="imageIcon" 
                    style="width: 40px; height: 20px; object-fit: contain;"/>
                </span>`
              : ''
          }
        </span>
      </div>
      `
            )
            .openOn(map);

          popupOpen = true;
        }
      };

      map.on('click', onMapClick);

      return () => {
        map.off('mousemove', onMouseMove);
        map.off('click', onMapClick);
        map.closePopup(popup);
        map.closeTooltip(tooltip);
        map.getContainer().style.cursor = '';
        if (heatmapLayer) {
          mapRef.current.removeLayer(heatmapLayer);
          setHeatmapLayer(null);
        }
      };
    }
  }, [isHeatMap, JobsData, mapRef, myJob]);


  useEffect(() => {
    if (JobsData && JobsData.jobs && JobsData?.jobs?.length > 0) {
      setMarkers([...JobsData.jobs]);
    } else {
      setMarkers([]);
    }
  }, [JobsData, myJob]);

  const resetToUserPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          console.log('Latitude:', latitude, 'Longitude:', longitude);

          updatePositionData({
            currentPosition: [latitude, longitude],
          });
          const geocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

          try {
            const response = await fetch(geocodingUrl);
            const data = await response.json();

            if (data.status === 'OK') {
            } else {
            }
          } catch (error) {}
        },
        (error) => {
          console.error('Error getting location:', error.message);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
    if (mapRef.current) {
      const newCenter = [locationData.lat || latitude, locationData.lng || longitude];
      mapRef.current.setView(newCenter, 13);
    }
  };

  const renderJobs = (item) => {
    const [jobLongitude, jobLatitude] = item.location.coordinates;

    return (
      <Marker key={item.jobNumber} position={[jobLatitude, jobLongitude]} icon={customIcon}>
        <Popup className="custom-popup">
          <Box
            display="grid"
            gridTemplateColumns={{ xs: '1fr 1fr', sm: '1fr 1fr' }}
            // gap={1}
            sx={{
              // p: 1.5,
              // borderRadius: 1,
              // boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              //  backgroundColor: 'transparent'
              borderRadius: 0, // Remove rounding
              boxShadow: 'none', // Remove shadow
              backgroundColor: 'transparent', // Remove background color
            }}
          >
            <Box>
              <Box
                display="grid"
                gridTemplateColumns="auto 1fr"
                alignItems="center"
                sx={{ mb: 1.5 }}
              >
                <Typography fontSize={14} variant="p" fontWeight="bold" color="text.secondary">
                  Job #:
                </Typography>
                <Typography ml={1} fontWeight="bold" fontSize={14} variant="p" color="text.primary">
                  <Tooltip placement="top" title={item?.jobNumber}>
                    {item?.jobNumber.length > 11
                      ? item?.jobNumber.slice(0, 9) + '...'
                      : item?.jobNumber}
                  </Tooltip>
                </Typography>
              </Box>
              <Box
                display="grid"
                gridTemplateColumns="auto 1fr"
                alignItems="center"
                sx={{ mb: 1.5 }}
              >
                <Typography fontSize={14} variant="p" fontWeight="bold" color="text.secondary">
                  Price:
                </Typography>
                <Box ml={1} display="flex" alignItems="center">
                  <Iconify
                    icon="mdi:dollar"
                    sx={{
                      height: '18px',
                      width: '17px',
                      color: 'text.primary',
                      mr: 0.5,
                    }}
                  />
                  <Typography fontWeight="bold" fontSize={14} variant="p" color="text.primary">
                    {formatPrice(item?.price)}
                  </Typography>
                </Box>
              </Box>
              <Box display="grid" gridTemplateColumns="auto 1fr" alignItems="center">
                <Typography fontSize={14} variant="p" fontWeight="bold" color="text.secondary">
                  Lead Code:
                </Typography>
                <Typography ml={1} fontSize={14} variant="p" fontWeight="bold" color="text.primary">
                  {item?.leadCode || 'N/A'}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box
                display="grid"
                gridTemplateColumns="auto 1fr"
                alignItems="center"
                sx={{ mb: 1.5 }}
              >
                <Typography fontSize={14} variant="p" fontWeight="bold" color="text.secondary">
                  Date:
                </Typography>
                <Typography ml={1} fontSize={14} variant="p" fontWeight="bold" color="text.primary">
                  {fDate(item?.installationDate)}
                </Typography>
              </Box>
              <Box display="grid" gridTemplateColumns="auto 1fr" alignItems="center">
                <Typography fontSize={14} variant="p" fontWeight="bold" color="text.secondary">
                  Sales Rep:
                </Typography>
                <Typography ml={1} fontSize={14} variant="p" fontWeight="bold" color="text.primary">
                  {item?.rep || item?.userName}
                </Typography>
              </Box>
              {user?.roleName === 'Marketing Manager' && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  // gap={1}
                  sx={{
                    mt: 1.5,
                    bgcolor: 'primary.light',
                    color: 'primary.dark',
                    // py: 1,
                    px: 1,
                    borderRadius: 1,
                    // mb: 1.5,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      bgcolor: 'primary.main',
                      color: 'primary.contrastText',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    },
                  }}
                >
                  <Typography fontSize={14} variant="p" fontWeight="bold">
                    Route#:
                  </Typography>
                  <Link
                    // href="#target-section"
                    onClick={confirm.onTrue}
                    variant="body2"
                    underline="none"
                    sx={{
                      color: 'inherit',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }}
                  >
                    2255685
                  </Link>
                </Box>
              )}
            </Box>
          </Box>
          <Box
            mt={2}
            display="flex"
            alignItems="flex-start"
            sx={{
              borderTop: '1px solid',
              borderColor: 'divider',
              pt: 2,
            }}
          >
            <Typography fontSize={14} variant="p" fontWeight="bold" color="text.secondary">
              Address:
            </Typography>
            <Box sx={{ flexGrow: 1, ml: 1 }}>
              <Typography fontSize={14} variant="p" fontWeight="bold" color="text.primary">
                <Box
                  component="span"
                  sx={{
                    filter: 'blur(4px)',
                    display: 'inline',
                  }}
                >
                  {item?.streetName?.substring(0, 3) || item?.address?.streetName?.substring(0, 3)}
                </Box>
                {item?.streetName?.substring(3) || item?.address?.streetName?.substring(3)}
                <Box component="span">
                  , {item.city || item?.address?.city}, {item.state || item?.address?.state},{' '}
                  {item.zip || item?.address?.zip}
                </Box>
              </Typography>
            </Box>
            {item?.images?.beforeImages?.length > 0 && item?.images?.beforeImages?.length > 0 && (
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  cursor: 'pointer',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s',
                  ml: 1,
                  '&:hover': {
                    bgcolor: 'action.hover',
                    transform: 'scale(1.1)',
                  },
                }}
                onClick={() => handleOpenModal(item)}
              >
                <img
                  height="20"
                  width="20"
                  src={imageIcon}
                  alt="imageIcon"
                  style={{ objectFit: 'contain' }}
                />
              </Box>
            )}
          </Box>
        </Popup>
      </Marker>
    );
  };

  return (
    <>
      {latitude && longitude ? (
        <MapContainer
          center={locationData.lat ? [locationData.lat, locationData.lng] : [latitude, longitude]}
          // center={[37.7749,-122.4194]}
          zoom={13}
          style={{ height: '80vh', width: '100%', borderRadius: '20px' }}
          zoomControl={false} // Disable the default zoom controls
          ref={mapRef} // Set the map reference
        >
          {/* Custom Zoom Control */}
          <ZoomControl position="bottomright" className="custom-zoom-control" />

          {/* Custom Button to Reset Map */}
          <Box
            // variant="contained"
            // color="primary"
            onClick={resetToUserPosition}
            sx={{
              margin: 0,
              height: '50px',
              width: '50px',
              position: 'absolute',
              bottom: '15%',
              right: '5px',
              zIndex: 1000,
              backgroundColor: '#212b36',
              borderRadius: '100%', // Change button color
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              '@media (max-width: 499px)': {
                bottom: '40%',
              },
              '@media (max-width: 360px)': {
                bottom: '50%',
              },
              '@media (max-width: 375px)': {
                bottom: '50%',
              },
            }}
          >
            <Iconify
              style={{
                height: '30px',
                width: '30px',
                cursor: 'pointer',
                color: 'white',
                // position: 'relative',
                // top: '4px',
                // left: '-5px',
              }}
              icon="mdi:target"
            />
          </Box>
          <Box
            sx={{
              margin: 0,
              height: '50px',
              width: '50px',
              position: 'absolute',
              bottom: '21%',
              right: '3px',
              zIndex: 1000,
              display: {
                xs: 'flex',
                sm: 'none',
                lg: 'none',
                md: 'none',
              },
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              '@media (max-width: 499px)': {
                bottom: '23%',
              },
              '@media (max-width: 360px)': {
                bottom: '35%',
              },
              '@media (max-width: 390px)': {
                bottom: '24%',
              },
              '@media (max-width: 375px)': {
                bottom: '33%',
              },
            }}
          >
            <ToggleSwitch IsHeatMap={IsHeatMap} setIsHeatMap={setIsHeatMap} />
          </Box>
          {/* <Box
          sx={{
            margin: 0,
            height: '50px',
            width: '50px',
            position: 'absolute',
            bottom: '21%',
            right: '3px',
            zIndex: 1000,
            display: {
              xs: 'flex',
              sm: 'none',
              lg: 'none',
              md: 'none',
            },
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            '@media (max-width: 499px)': {
              bottom: '30%',
            },
            '@media (max-width: 360px)': {
              bottom: '25%',
            },
          }}
        >
          <ToggleSwitchFilterJobs myJobs={myJob} setMyJobs={setMyJobs} />
        </Box> */}

          {/* <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          /> */}

          <TileLayer
            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
            attribution='&copy; <a href="https://carto.com/">Carto</a>'
          />

          <Marker position={[latitude, longitude]} icon={userIcon}></Marker>
          {/* {!isHeatMap &&
          JobsData?.jobs?.length > 0 &&
          JobsData.jobs.map((item) => {
            if (myJob && item?.salesRepId == user?._id) {
              return renderJobs(item);
            } else if (!myJob) {
              return renderJobs(item);
            }
          })} */}
          {!isHeatMap && markers?.length > 0 && markers.map((item) => renderJobs(item))}
        </MapContainer>
      ) : (
        <LoadingScreen />
      )}
      <BeforeAfterModal open={open.value} item={selectedJob} onClose={() => open.onFalse()} />
      <Portal>
        <RouteModal
          open={confirm.value}
          onClose={confirm.onFalse}
          title={'Route Details'}
          data={{
            income: '10,000',
            totalHouse: 100,
            male: 30,
            female: 70,
          }}
          campaigns={campaigns}
        />
      </Portal>
    </>
  );
}
